import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AudioProvider } from './context/AudioContext';
import { DynamicThemeProvider } from './context/DynamicThemeContext';
import RadioPlayer from './components/RadioPlayer';
import UpdateBanner from './components/UpdateBanner';
import './App.css';

function App() {
  return (
    <AudioProvider>
      <DynamicThemeProvider>
        <BrowserRouter>
          <UpdateBanner />
          <Routes>
            <Route path="/" element={<RadioPlayer />} />
          </Routes>
        </BrowserRouter>
      </DynamicThemeProvider>
    </AudioProvider>
  );
}

export default App;